export default __webpack_public_path__ + "static/media/gus-rsi-logo-horizontal-pl.0ebb0614.png";